module.exports = __webpack_public_path__ + "assets/img/question.67e61d21.svg";